import { Indicator } from '../../../Common/Charts/Indicator';
import { useSummaryChartsDataContext } from './hooks/useSummaryChartsDataContext';

export const IdentificationIndex = () => {
    const { chartData } = useSummaryChartsDataContext();

    return (
        <Indicator
            title={'Indicador de Identificação'}
            indicatorValue={chartData?.indicators?.identificationIndex}
            height={300}
        />
    );
};
